import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/WarningAmberRounded";
import { red } from "@mui/material/colors";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import VerifiedIcon from "@mui/icons-material/Verified";

export default function ConfirmationApprove({
  confirmDelete,
  onAgree,
  onCancel,
  entityName = "Items",
  entityDescription,
  changeIcon,
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={confirmDelete}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: darkMode
            ? theme.palette.background.default
            : theme.palette.white.main,
          px: 3,
          py: 3,
          width: { xs: 370, md: 460 },
          boxShadow: theme.shadows[5],
          border: darkMode ? "1px solid #2c2c3e" : "1px solid #d1d5db",
        },
      }}
    >
      {/* Warning Icon */}
      <Box display="flex" justifyContent="center" mb={2}>
        <Box
          sx={{
            p: 2,
            bgcolor: red[100],
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {changeIcon ? (
            <VerifiedIcon sx={{ color: "#4CAF50", fontSize: 28 }} />
          ) : (
            <WarningIcon sx={{ color: red[600], fontSize: 28 }} />
          )}
        </Box>
      </Box>

      {/* Title */}
      {entityDescription ? (
        <DialogTitle sx={{ p: 0, textAlign: "center" }}>
          <Typography variant="h6" fontWeight={600} color="text">
            {entityDescription}
          </Typography>
        </DialogTitle>
      ) : (
        <DialogContent sx={{ mt: 1, p: 0 }}>
          <Typography variant="body2" color="text" textAlign="center">
            Do you really want to delete the selected{" "}
            <strong>{entityName}</strong>?
            <br />
            This action cannot be undone.
          </Typography>
        </DialogContent>
      )}

      {/* Message */}

      {/* Action Buttons */}
      <DialogActions
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexDirection: { xs: "column", md: "row" },
          px: 0,
        }}
      >
        <MDButton
          onClick={onCancel}
          variant="outlined"
          color="text"
          sx={{
            width: { xs: "100%", md: 140 },
            height: 40,
            fontWeight: 500,
            fontSize: 14,
            textTransform: "none",
            borderColor: "#d1d5db",
            "&:hover": {
              backgroundColor: "#f3f4f6",
              color: "#111827",
              borderColor: "#d1d5db",
            },
          }}
        >
          Cancel
        </MDButton>

        <MDButton
          onClick={onAgree}
          variant="outlined"
          color="error"
          sx={{
            width: { xs: "100%", md: 140 },
            height: 40,
            fontWeight: 500,
            fontSize: 14,
            textTransform: "none",
            "&:hover": {
              backgroundColor: red[700],
              color: "#fff",
              borderColor: red[700],
            },
          }}
        >
          Confirm
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
